module.exports = { "default": require("core-js/library/fn/object/define-properties"), __esModule: true };